import httpClient from "../httpClient";
import { TokenService } from "../storage.service";

const END_POINT = "Auth";

class AccountService {
  async login(user) {
    const params = {
      userName: user.username,
      passWord: user.password,
    };

    const config = {
      method: "post",
      url: `${END_POINT}/Login`,
      data: params,
      headers: {
        "content-type": "application/json",
      },
    };

    const response = await httpClient(config);

    if (response && response?.data) {
      const { accessToken, refreshToken, userId } = response.data;
      const { status } = response;

      if (status && accessToken && refreshToken) {
        TokenService.saveToken(accessToken);
        TokenService.saveRefreshToken(refreshToken);

        return { status: true, accessToken: accessToken, refreshToken, userId };
      } else {
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  async logout() {
    const params = {
      RefreshToken: TokenService.getRefreshToken(),
    };

    const config = {
      method: "post",
      url: `${END_POINT}/Logout`,
      data: params,
      headers: {
        "content-type": "application/json",
      },
    };

    const response = await httpClient(config);

    if (response && response?.status) {
      TokenService.removeToken();
      TokenService.removeRefreshToken();
    } else {
      TokenService.removeToken();
      TokenService.removeRefreshToken();
    }
    return true;
  }

  async refreshToken() {
    const config = {
      method: "post",
      url: `${END_POINT}/RefreshToken`,
      data: {
        token: TokenService.getRefreshToken(),
      },
      headers: {
        Authorization: null,
      },
    };

    const response = await httpClient(config);

    if (response) {
      const { token, refreshToken } = response;

      if (token && refreshToken) {
        TokenService.saveToken(token);
        TokenService.saveRefreshToken(refreshToken);
      } else {
        return null;
      }

      return { accessToken: token, refreshToken };
    } else {
      return null;
    }
  }
}

export default new AccountService();
